// extracted by mini-css-extract-plugin
module.exports = {"hero-banner":"hero-banner_hero-banner__d2tL9","hero-banner__headline":"hero-banner_hero-banner__headline__7mwzU"};